/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRoleAllGet } from '../fn/role/api-role-all-get';
import { ApiRoleAllGet$Params } from '../fn/role/api-role-all-get';
import { apiRoleCheckRoleByUserPost } from '../fn/role/api-role-check-role-by-user-post';
import { ApiRoleCheckRoleByUserPost$Params } from '../fn/role/api-role-check-role-by-user-post';
import { apiRoleCheckUserByRolePost } from '../fn/role/api-role-check-user-by-role-post';
import { ApiRoleCheckUserByRolePost$Params } from '../fn/role/api-role-check-user-by-role-post';
import { apiRoleDelete } from '../fn/role/api-role-delete';
import { ApiRoleDelete$Params } from '../fn/role/api-role-delete';
import { apiRoleGet } from '../fn/role/api-role-get';
import { ApiRoleGet$Params } from '../fn/role/api-role-get';
import { apiRoleOptRoleCollectionsGet } from '../fn/role/api-role-opt-role-collections-get';
import { ApiRoleOptRoleCollectionsGet$Params } from '../fn/role/api-role-opt-role-collections-get';
import { apiRoleOptUserStartwithGet } from '../fn/role/api-role-opt-user-startwith-get';
import { ApiRoleOptUserStartwithGet$Params } from '../fn/role/api-role-opt-user-startwith-get';
import { apiRolePost } from '../fn/role/api-role-post';
import { ApiRolePost$Params } from '../fn/role/api-role-post';
import { apiRolePut } from '../fn/role/api-role-put';
import { ApiRolePut$Params } from '../fn/role/api-role-put';
import { ManageUserProfile } from '../models/manage-user-profile';
import { RoleByUserRes } from '../models/role-by-user-res';
import { RoleCollectionOptDataRes } from '../models/role-collection-opt-data-res';
import { RoleGroupDto } from '../models/role-group-dto';
import { RoleGroupListRes } from '../models/role-group-list-res';
import { UserByRoleRes } from '../models/user-by-role-res';

@Injectable({ providedIn: 'root' })
export class RoleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRoleAllGet()` */
  static readonly ApiRoleAllGetPath = '/api/role/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoleAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleAllGet$Response(params?: ApiRoleAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RoleGroupListRes>>> {
    return apiRoleAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoleAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleAllGet(params?: ApiRoleAllGet$Params, context?: HttpContext): Observable<Array<RoleGroupListRes>> {
    return this.apiRoleAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RoleGroupListRes>>): Array<RoleGroupListRes> => r.body)
    );
  }

  /** Path part for operation `apiRoleGet()` */
  static readonly ApiRoleGetPath = '/api/role';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleGet$Response(params?: ApiRoleGet$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleGroupDto>> {
    return apiRoleGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleGet(params?: ApiRoleGet$Params, context?: HttpContext): Observable<RoleGroupDto> {
    return this.apiRoleGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleGroupDto>): RoleGroupDto => r.body)
    );
  }

  /** Path part for operation `apiRolePut()` */
  static readonly ApiRolePutPath = '/api/role';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRolePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRolePut$Response(params?: ApiRolePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiRolePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRolePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRolePut(params?: ApiRolePut$Params, context?: HttpContext): Observable<void> {
    return this.apiRolePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiRolePost()` */
  static readonly ApiRolePostPath = '/api/role';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRolePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRolePost$Response(params?: ApiRolePost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiRolePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRolePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRolePost(params?: ApiRolePost$Params, context?: HttpContext): Observable<string> {
    return this.apiRolePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiRoleDelete()` */
  static readonly ApiRoleDeletePath = '/api/role';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoleDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleDelete$Response(params?: ApiRoleDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiRoleDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoleDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleDelete(params?: ApiRoleDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiRoleDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiRoleOptRoleCollectionsGet()` */
  static readonly ApiRoleOptRoleCollectionsGetPath = '/api/role/opt/role-collections';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoleOptRoleCollectionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleOptRoleCollectionsGet$Response(params?: ApiRoleOptRoleCollectionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RoleCollectionOptDataRes>>> {
    return apiRoleOptRoleCollectionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoleOptRoleCollectionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleOptRoleCollectionsGet(params?: ApiRoleOptRoleCollectionsGet$Params, context?: HttpContext): Observable<Array<RoleCollectionOptDataRes>> {
    return this.apiRoleOptRoleCollectionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RoleCollectionOptDataRes>>): Array<RoleCollectionOptDataRes> => r.body)
    );
  }

  /** Path part for operation `apiRoleOptUserStartwithGet()` */
  static readonly ApiRoleOptUserStartwithGetPath = '/api/role/opt/user/startwith';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoleOptUserStartwithGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleOptUserStartwithGet$Response(params?: ApiRoleOptUserStartwithGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ManageUserProfile>>> {
    return apiRoleOptUserStartwithGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoleOptUserStartwithGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleOptUserStartwithGet(params?: ApiRoleOptUserStartwithGet$Params, context?: HttpContext): Observable<Array<ManageUserProfile>> {
    return this.apiRoleOptUserStartwithGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ManageUserProfile>>): Array<ManageUserProfile> => r.body)
    );
  }

  /** Path part for operation `apiRoleCheckUserByRolePost()` */
  static readonly ApiRoleCheckUserByRolePostPath = '/api/role/check-user-by-role';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoleCheckUserByRolePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleCheckUserByRolePost$Response(params?: ApiRoleCheckUserByRolePost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserByRoleRes>>> {
    return apiRoleCheckUserByRolePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoleCheckUserByRolePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleCheckUserByRolePost(params?: ApiRoleCheckUserByRolePost$Params, context?: HttpContext): Observable<Array<UserByRoleRes>> {
    return this.apiRoleCheckUserByRolePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserByRoleRes>>): Array<UserByRoleRes> => r.body)
    );
  }

  /** Path part for operation `apiRoleCheckRoleByUserPost()` */
  static readonly ApiRoleCheckRoleByUserPostPath = '/api/role/check-role-by-user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoleCheckRoleByUserPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleCheckRoleByUserPost$Response(params?: ApiRoleCheckRoleByUserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RoleByUserRes>>> {
    return apiRoleCheckRoleByUserPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoleCheckRoleByUserPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoleCheckRoleByUserPost(params?: ApiRoleCheckRoleByUserPost$Params, context?: HttpContext): Observable<Array<RoleByUserRes>> {
    return this.apiRoleCheckRoleByUserPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RoleByUserRes>>): Array<RoleByUserRes> => r.body)
    );
  }

}
